import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5760ac95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = ["id"]

import { ref, onMounted, inject, PropType } from "vue";
import { ContactFindTypeRestriction } from "@/enums/contacts/ContactFindTypeRestriction";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import { Contacts } from "acquaint-api/models/Contacts";
import { getErrorMessage } from "bright-logic-core/src/errors";
import FindContactResults from "@/components/find/contacts/find-contact-results.vue";
import { DxTextBox, DxButton } from "devextreme-vue/text-box";
import { DxTooltip } from "devextreme-vue/tooltip";
import displayErrorMessage from "@/utils/ErrorHandling";


export default /*#__PURE__*/_defineComponent({
  __name: 'switch-contact-lookup',
  props: {
  /**
   * Specifies the type of contact search restriction (e.g., None, Email, Phone, etc.).
   * This determines how the contact lookup is filtered or restricted.
   * @type {Number}
   * @default ContactFindTypeRestriction.None
   */
  findTypeRestriction: {
    type: Number as PropType<ContactFindTypeRestriction>,
    default: ContactFindTypeRestriction.None,
  },
  /**
   * The label text displayed for the control.
   * This is typically shown next to or above the input field.
   * @type {string}
   * @default 'Look up contact'
   */
  label: {
    type: String,
    default: "Look up contact",
  },
  /**
   * The maximum width for the results dropdown or container.
   * This controls the width of the displayed results.
   * @type {string}
   * @default '100%'
   */
  resultsMaxWidth: {
    type: String,
    default: "100%",
  },
  /**
   * The unique identifier for the tooltip element.
   * This is used to associate the tooltip with its target element.
   * @type {string}
   * @optional
   */
  toolTipId: {
    type: String,
    default: "",
  },
  /**
   * The target element or selector for the tooltip.
   * This specifies where the tooltip should be displayed.
   * @type {string}
   * @optional
   */
  toolTipTarget: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Emitted when a contact is selected.
   * Passes the selected contact's details to the parent component.
   * @param {Contacts | undefined} contactDetails - The details of the selected contact.
   */
  "contactSelected",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "fc7cb170": (__props.resultsMaxWidth)
}))

const searchQuery = ref("");
const displayResults = ref(false);
const findResults = ref<ContactFindResult[]>([]);
const restrictedResults = ref<ContactFindResult[]>([]);
const searching = ref(false);

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;





onMounted(() => {
  document.addEventListener("click", () => {
    displayResults.value = false;
  });
});

const searchButtonOptions = {
  icon: "search",
  stylingMode: "text",
  type: "dx-dropdowneditor-button",
  disabled: false,
  onClick: () => searchClick(searchQuery.value),
};

const searchClick = async (value: string) => {
  // To avoid unnecessary api calls, only perform search if user has entered more than 2 characters
  if (!value || value.length < 2) {
    restrictedResults.value = [];
    return;
  }

  searching.value = true;

  // Currently there are no filters, so set filters to all
  const postData = {
    textToFind: value,
    maxResults: 200,
    findTypeRestriction: props.findTypeRestriction,
    filters: {
      statusID: -1,
      typeID: -1,
      userID: -1,
      branchID: -1,
    },
  };

  // Get results back from api
  try {
    findResults.value = await apiClient.httpPost<ContactFindResult[]>(
      "find/contact",
      postData,
    );
    restrictedResults.value = findResults.value.filter(
      (contact) => !contact.isRestricted,
    );
    displayResults.value = true;
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
  }

  searching.value = false;
};

/** Handles the click events of the Find Contact Results */
const onGridSelect = async (e: ContactFindResult) => {
  displayResults.value = false;
  await selectContact(e.id);
};

// Handles the adaptive click of the grid
const onMoreInfoClick = async (e: ContactFindResult) => {
  await selectContact(e.id);
};

const selectContact = async (id: number) => {
  if (!id) {
    return;
  }

  const contactDetails = await getContactDetailsFromApi(id);

  if (contactDetails) {
    emit("contactSelected", contactDetails);
  }
};

const getContactDetailsFromApi = async (id: number) => {
  try {
    return await apiClient.httpGet<Contacts>(`database/contacts/${id}`);
  } catch (ex) {
    displayErrorMessage("Could not find the contact's information.");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(__props.label), 1),
      _createElementVNode("i", {
        class: "fas fa-info-circle info-icon",
        id: props.toolTipId
      }, null, 8, _hoisted_2)
    ]),
    _createVNode(_unref(DxTextBox), {
      value: searchQuery.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      "read-only": false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DxButton), {
          name: "contact-lookup",
          position: "after",
          options: searchButtonOptions
        })
      ]),
      _: 1
    }, 8, ["value"]),
    (displayResults.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "results-table-container",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(FindContactResults, {
            data: restrictedResults.value,
            searching: searching.value,
            onRowClick: onGridSelect,
            onRowSelected: onGridSelect,
            onAdaptiveRowSelection: onMoreInfoClick
          }, null, 8, ["data", "searching"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(DxTooltip), {
      target: props.toolTipTarget,
      "show-event": "mouseenter",
      width: "275px",
      position: "top",
      "hide-event": "mouseleave"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tooltip-content")
      ]),
      _: 3
    }, 8, ["target"])
  ]))
}
}

})